window.global = window.global || window;

module.exports = window.global;
